/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  button: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  disabled: PropTypes.bool,
  options: PropTypes.array,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  customButton: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
};

const defaultProps = {
  title: '',
  button: false,
  disabled: false,
  options: [],
  style: {},
  customButton: false,
};

const TitleSubSection = (props) => {
  const {
    title = '',
    button = false,
    disabled = false,
    options = [],
    style = {},
    customButton = false,
  } = props;

  const [showOption, setShowOption] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setShowOption(false);
    }
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <View
      style={[
        styles.titleContainer,
        { paddingVertical: button ? 8 : 17 },
        button || customButton
          ? {
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }
          : {},
        style,
      ]}>
      <SociollaText type="medium" style={styles.text}>
        {title}
      </SociollaText>
      {button ? (
        <Button
          type="default"
          rounded
          buttonStyle={styles.buttonItem}
          disabledStyle={styles.buttonItem}
          disabled={disabled}
          title={
            <SociollaText type="bold" style={styles.buttonText}>
              {button.label}
            </SociollaText>
          }
          onPress={() =>
            options?.length ? setShowOption(!showOption) : button.callback()
          }
        />
      ) : (
        false
      )}
      {options?.length && showOption ? (
        <View style={styles.addOptions}>
          {options.map((item, idx) => (
            <TouchableOpacity
              key={idx}
              activeOpacity={0.8}
              style={styles.addOptionsItem}
              onPress={() => {
                item.callback();
                setShowOption(false);
              }}>
              <SociollaText>{item.label}</SociollaText>
            </TouchableOpacity>
          ))}
        </View>
      ) : (
        false
      )}
      {customButton ? customButton : false}
    </View>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    width: '100%',
    backgroundColor: Colors.grey3,
    paddingHorizontal: 15,
  },
  text: { color: Colors.grey1 },
  buttonItem: { width: 150 },
  buttonText: { fontSize: 14, letterSpacing: 0.5, color: Colors.black },
  addOptions: {
    position: 'absolute',
    width: 150,
    top: 45,
    right: 15,
    zIndex: 1,
    elevation: 1,
    backgroundColor: Colors.white,
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
  },
  addOptionsItem: {
    paddingVertical: 13,
    paddingHorizontal: 15,
  },
});

TitleSubSection.propTypes = propTypes;
TitleSubSection.defaultProps = defaultProps;

export default TitleSubSection;
